function compressWord({ brx, bry, tlx, tly, word }) {
    return [brx, bry, tlx, tly, word];
}

function decompressWord([brx, bry, tlx, tly, word]) {
    return { brx, bry, tlx, tly, word };
}

function compressLine({ brx, bry, tlx, tly, words }) {
    return [brx, bry, tlx, tly, ...words.map(compressWord)];
}

function decompressLine([brx, bry, tlx, tly, ...words]) {
    return { brx, bry, tlx, tly, words: words.map(decompressWord) };
}

export function wordCompressor(wordData) {
    return wordData.words.map(compressLine);
}

export function wordDecompressor(wordData) {
    return {
        words: wordData.map(decompressLine),
    };
}



// WEBPACK FOOTER //
// ./src/word_compressor.js